import { eUserRole } from './User.enums';
import { tUserContext } from './User.types';

export const initialState: tUserContext = {
  idToken: undefined,
  currentUserId: undefined,
  currentUser: undefined,
  setCurrentUser: () => {},
  hasSession: false,
  onSignInWithEmailAndPasswordSubmit: async () => {},
  onSignUpSubmit: async () => {},
  onSignOut: async () => {},
  onAccountRecoverySubmit: async () => {},
  currentUserRole: eUserRole.SELLER,
  setCurrentUserRole: () => {},
  userRoleSettlement: undefined,
  setUserRoleSettlement: () => {},
  onSignInWithGoogle: () => {},
  googleLoggingIn: false,
  updateNameAndPhoneProfile: async () => {},
  retrieveGoogleSignInResult: async () => {},
  onSignUpWithGoogle: async () => {},
};
